import "./base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Models ??= {};

AssessmentBuilder.Models.Intro = class Intro extends AssessmentBuilder.Models.Base {
  defaults() {
    return {
      enabled: true,
      instructions: "",
      footer: "",
    };
  }
};
